import {
  AggregatedData,
  WidgetDataType,
  WidgetNoneType,
} from '@atlas-metrics/microsite-types';
import React, { useEffect, useState } from 'react';

import { FormatValueFn } from '@/hooks/useFormatValue';

import PieChartWithLegends from './PieChartWithLegends';
import { getPieChartWidgetContent } from './utils';
import ElevatedCard from '../ui/ElevatedCard';
import HorizontalDivider from '../ui/HorizontalDivider';
import WidgetRow from '../ui/WidgetRow';

import { PieChartDisclosureResult } from '@/types';

type Props = {
  disclosureTitle: string;
  title: string;
  result: number;
  unit: string;
  data: AggregatedData;
  dataType: WidgetDataType | WidgetNoneType;
  formatValue: FormatValueFn;
};

const PieChartWidget: React.FC<Props> = ({
  disclosureTitle,
  title,
  unit,
  data,
  dataType,
  formatValue,
}) => {
  const [pieChartData, setPieChartData] = useState<PieChartDisclosureResult[]>(
    []
  );

  // NextJS fails to hydrate victory charts with data -- thus, we need to move the rendering into the client
  useEffect(() => {
    setPieChartData(getPieChartWidgetContent(data, disclosureTitle));
  }, [data, disclosureTitle]);

  const shouldShowTitle = () => {
    if (pieChartData?.length > 1) {
      return true;
    }

    if (
      pieChartData?.length === 1 &&
      pieChartData[0].name !== disclosureTitle
    ) {
      return true;
    }

    return false;
  };

  return (
    <ElevatedCard>
      {shouldShowTitle() && (
        <>
          <WidgetRow title={disclosureTitle} hideHorizontalDivider />
          <HorizontalDivider />
        </>
      )}
      <PieChartWithLegends
        title={title}
        unit={unit}
        dataType={dataType}
        data={pieChartData}
        formatValue={formatValue}
      />
    </ElevatedCard>
  );
};

export default PieChartWidget;
